//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Xgrid from '@/components/common/x-grid'
import BScroll from 'better-scroll'
import { Swiper, Slide } from 'vue-swiper-component';
  export default {
    data() {
      return {
        planBScroll: null,
        current:{},
        SlideList:[]
      }
    },
    components: {
        Xgrid,
        Swiper,
        Slide
    },
    computed: {
      height() {
        return `${Math.ceil((this.list.length) / 3 ) * 5.9}rem`
      }
    },
    props: {
      list: {
        type: Array,
        default: ()=>{
          return []
        }
      },
    },
    mounted () {
      if(this.list.length - 9 >0){
        let arr1 = this.list.slice(0,9)
        let arr2 = this.list.slice(9,this.list.length)
        // console.log(this.list)
        this.SlideList = [arr1,arr2]
      }else{
        this.SlideList = [this.list]
      }
    },
    methods: {
      change(item){
        this.current =  item;
        this.$emit('input',item)
        this.STATISTICS_CONFIG.insur_choosetype_type_click({  "ex":{name:item.category }})
      },
    },
  }
